import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { DecoratedRangePickerFirstField } from './InputField'

export { DecoratedRangePickerFirstField }

export default Loadable(() => import('./RangeDatePicker'))
